var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-76a4f2f5-c70c-42c7-9528-ef1efee27a5b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.75 36.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-d43bea57-145d-441b-8730-ffd6d3aafb92, .uuid-8ed484c1-8937-42a5-8fc6-7f1d6b608332 {\n        fill: #0092ff;\n      }\n\n      .uuid-8ed484c1-8937-42a5-8fc6-7f1d6b608332 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-29369d6d-ae41-4253-861c-ea1f62e23554",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-8ed484c1-8937-42a5-8fc6-7f1d6b608332",
    x: 3.91,
    y: 2.89,
    width: 15.77,
    height: 15.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-8ed484c1-8937-42a5-8fc6-7f1d6b608332",
    d: "M31.31,19.8l-2.53-2.68c-1.08-1.15-1.68-2.66-1.68-4.24V7.33c0-.84,1.05-1.22,1.59-.58l2.75,3.29c.93,1.11,1.43,2.51,1.43,3.95v5.18c0,.82-1,1.21-1.56,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d43bea57-145d-441b-8730-ffd6d3aafb92",
    d: "M32.21,18.36l-1.95-1.82c-.98-.91-1.54-2.19-1.54-3.53V4.8c0-2.65-2.15-4.8-4.8-4.8H4.8C2.15,0,0,2.15,0,4.8V31.56c0,2.66,2.16,4.82,4.82,4.82H28.92c2.66,0,4.82-2.16,4.82-4.82v-9.67c0-1.34-.56-2.62-1.54-3.53Zm-19.92-2.98H7.42c-.89,0-1.6-.72-1.6-1.6s.72-1.6,1.6-1.6h4.87c.89,0,1.6,.72,1.6,1.6s-.72,1.6-1.6,1.6Zm5.61-6.58c0,.89-.72,1.6-1.6,1.6H7.03c-.89,0-1.6-.72-1.6-1.6v-1.39c0-.89,.72-1.6,1.6-1.6h9.26c.89,0,1.6,.72,1.6,1.6v1.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d7c1b1f3ade70ada2a1e556003b0f0fe.svg";
export { ForwardRef as ReactComponent };